export type Locale = "fa" | "en";

export const content = {
  fa: {
    brand: "لینگوگرام",
    nav: ["چطور یاد می‌گیری؟", "داخل اپ", "سؤال‌های رایج"],
    download: "دانلود برای اندروید",
    skip: "رفتن به محتوای اصلی",
    menu: "منوی اصلی",
    close: "بستن منو",
    badge: "یادگیری انگلیسی با ویدیو و تمرین",
    hero: ["انگلیسیِ واقعی یاد بگیر.", "با ویدیو و تمرین."],
    intro:
      "بعضی کلمه‌ها رو بلدی، ولی موقع حرف زدن نمی‌دونی چطور کنارشون بذاری؟ توی لینگوگرام، عبارت‌های پرکاربرد رو در ویدیو می‌بینی، کاربردشون رو یاد می‌گیری و تمرین می‌کنی.",
    explore: "یک عبارت یاد بگیر",
    android: "مخصوص اندروید",
    direct: "دانلود مستقیم فایل نصب",
    version: "نسخه",
    screenNote: "این تصاویر از خود اپ اندروید گرفته شده‌اند",
    lessons: {
      label: "یک دقیقه برای انگلیسیِ واقعی",
      title: "همین‌جا، یک عبارت یاد بگیر.",
      body: "یک عبارت رو انتخاب کن. توی صحنه‌های سریال بشنو و با توضیح فارسی، معنی و کاربردش رو یاد بگیر.",
      watch: "تماشای درس",
      categories: ["وقت و عجله", "احساسات روزمره", "انتخاب و تصمیم"],
      descriptions: [
        "وقتی وقتت کمه، چطور می‌گی «عجله دارم»؟",
        "وقتی تحت فشاری، چطور می‌گی «استرس دارم»؟",
        "ترکیب طبیعیِ کلمه‌ها برای «تصمیم گرفتن».",
      ],
      note: "۳ درس کوتاه · صدا و زیرنویس انگلیسی · توضیح فارسی",
      next: "ببین توی اپ چطور ادامه می‌دی",
      error: "ویدیو پخش نشد. دوباره امتحان کن یا فایل رو مستقیم باز کن.",
      retry: "تلاش دوباره",
      open: "باز کردن ویدیو",
    },
    pillars: [
      "ویدیوهای واقعی",
      "توضیح و مثال",
      "تمرین همراه با پاسخ",
      "یادگیری قدم‌به‌قدم",
    ],
    philosophyLabel: "طبیعی‌تر انگلیسی حرف بزن",
    philosophy: "کلمه‌ها رو بلدی؛",
    philosophyAccent: "حالا ترکیب درستشون رو یاد بگیر.",
    philosophyBody:
      "مثلاً برای «تصمیم گرفتن» می‌گیم make a decision. به این ترکیب‌های رایج می‌گن کالوکیشن. توی لینگوگرام یاد می‌گیری کدوم کلمه‌ها معمولاً کنار هم میان و چطور ازشون استفاده کنی.",
    exampleLabel: "مثلاً برای «تصمیم گرفتن» می‌گیم:",
    exampleTranslation: "make a decision یعنی تصمیم گرفتن",
    methodLabel: "توی هر درس چه کار می‌کنی؟",
    methodTitle: "اول ببین، بعد یاد بگیر و تمرین کن.",
    methodBody:
      "هر درس چند مرحله داره. از دیدن کاربرد یک عبارت شروع می‌کنی و با تمرین، خودت رو محک می‌زنی.",
    steps: [
      {
        title: "عبارت رو توی یک ویدیو ببین",
        short: "ببین",
        body: "با ویدیو و زیرنویس می‌بینی یک عبارت کجا و چطور استفاده می‌شه. هم تلفظش رو می‌شنوی، هم موقعیتی که توش به کار می‌ره.",
        label: "یادگیری با ویدیو و زیرنویس",
      },
      {
        title: "معنی و کاربردش رو یاد بگیر",
        short: "یاد بگیر",
        body: "توضیح‌ها و مثال‌های درس بهت کمک می‌کنن بفهمی چه کلمه‌هایی کنار هم میان و کِی ازشون استفاده کنی.",
        label: "نکته‌ها و مثال‌های هر درس",
      },
      {
        title: "تمرین کن و جواب رو بررسی کن",
        short: "تمرین کن",
        body: "به سؤال‌ها جواب بده و توضیح هر پاسخ رو بخون. اگر اشتباه کنی، می‌فهمی چرا و جواب درست چی بوده.",
        label: "تمرین همراه با توضیح پاسخ",
      },
    ],
    experienceLabel: "ادامه دادن راحت‌تر می‌شه",
    experienceTitle: "بدون کجای راهی،\nدرس بعدی رو شروع کن.",
    experienceBody:
      "درس‌هایی که گذروندی و مرحله‌ای که توش هستی مشخصه. هر وقت برگشتی، می‌دونی از کجا ادامه بدی.",
    journeyTitle: "مسیر یادگیریت مشخصه",
    journeyBody:
      "درس‌های تموم‌شده و درس بعدی رو روی نقشه ببین و قدم‌به‌قدم جلو برو.",
    libraryTitle: "عبارت‌ها رو نگه دار",
    libraryBody:
      "هر عبارتی رو که ذخیره کنی، توی کتابخونه‌ات پیدا می‌کنی تا بعداً دوباره بخونیش.",
    progressTitle: "پیشرفتت رو ببین",
    progressBody:
      "درس‌های تموم‌شده و روزهایی که پشت سر هم تمرین کردی، نشون می‌دن چقدر جلو رفتی.",
    galleryLabel: "نگاهی به داخل اپ",
    galleryTitle: "قبل از نصب، اپ رو ببین.",
    galleryBody: "روی هر بخش بزن تا تصویرش رو ببینی.",
    galleryTabs: ["مسیر یادگیری", "ویدیو و تمرین", "نکته‌های درس", "کتابخانه"],
    galleryDescriptions: [
      "اینجا می‌بینی چه درس‌هایی رو گذروندی و درس بعدیت چیه.",
      "ویدیو رو ببین، تمرین کن و توضیح جواب رو بخون.",
      "نکته‌ها و مثال‌هایی که کمک می‌کنن کاربرد عبارت‌ها رو بهتر بفهمی.",
      "عبارت‌های ذخیره‌شده‌ات اینجا جمع می‌شن.",
    ],
    actualScreen: "تصویر واقعی از اپ",
    screenshotLanguage: "منوها و محتوای آموزشی نسخه فعلی اپ انگلیسی هستن.",
    faqLabel: "شاید سؤال تو هم باشه",
    faqTitle: "قبل از شروع",
    faqs: [
      [
        "لینگوگرام برای چه سطحی مناسبه؟",
        "اگر انگلیسی پایه رو بلدی و می‌خوای عبارت‌های کاربردی‌تر یاد بگیری و طبیعی‌تر حرف بزنی، لینگوگرام می‌تونه بهت کمک کنه. نسخه فعلی روی کالوکیشن‌ها، یعنی ترکیب‌های رایج کلمه‌ها، تمرکز داره.",
      ],
      [
        "خود اپ هم فارسیه؟",
        "نه، منوها و محتوای آموزشی نسخه فعلی اپ انگلیسی هستن. سایت رو می‌تونی به فارسی یا انگلیسی ببینی. تصاویر همین صفحه هم محیط واقعی اپ رو نشون می‌دن.",
      ],
      [
        "چطور روی گوشیم نصبش کنم؟",
        "دکمه «دانلود برای اندروید» رو بزن و فایل دانلودشده رو باز کن. اگر گوشی اجازه نصب از مرورگر خواست، اجازه بده و نصب رو ادامه بده. فایل نصب رو از همین سایت بگیر.",
      ],
      [
        "بدون اینترنت هم می‌شه استفاده کرد؟",
        "برای دریافت درس‌ها و پخش ویدیوها به اینترنت نیاز داری.",
      ],
      [
        "روی آیفون هم نصب می‌شه؟",
        "فعلاً فقط نسخه اندروید در دسترسه و هنوز نسخه آیفون منتشر نشده.",
      ],
    ],
    ctaLabel: "آماده‌ای شروع کنی؟",
    ctaTitle: "نصب کن،\nاولین درست رو ببین.",
    ctaBody: "فایل نصب رو مستقیم از همین‌جا بگیر. نیازی به گوگل‌پلی نداری.",
    install: [
      "فایل نصب رو دانلود کن",
      "بازش کن و اجازه نصب بده",
      "اپ رو باز کن و شروع کن",
    ],
    requirement: "اندروید ۷ به بالا",
    footer: "یادگیری انگلیسی با ویدیو و تمرین",
    rights: "تمام حقوق محفوظ است.",
    back: "بالای صفحه",
    title: "لینگوگرام | یادگیری انگلیسی با ویدیو و تمرین",
    description:
      "با لینگوگرام عبارت‌های پرکاربرد انگلیسی رو در ویدیو ببین، کاربردشون رو یاد بگیر و تمرین کن. دانلود مستقیم اپ برای اندروید.",
  },
  en: {
    brand: "Lingogram",
    nav: ["How it works", "Inside the app", "Questions"],
    download: "Get for Android",
    skip: "Skip to main content",
    menu: "Main menu",
    close: "Close menu",
    badge: "A fresh way to experience English",
    hero: ["English for real life.", "One phrase at a time."],
    intro:
      "Go from understanding a sentence to making it your own. Discover real videos, clear explanations, and short practice sessions that bring English into your world.",
    explore: "Try a short lesson",
    android: "Made for Android",
    direct: "Direct download",
    version: "Version",
    screenNote: "Actual screenshots from Lingogram for Android",
    lessons: {
      label: "A MINUTE OF REAL ENGLISH",
      title: "Learn your first phrase. Right here.",
      body: "Pick a phrase. Hear it in TV scenes, then explore its meaning and use with Persian explanations.",
      watch: "Watch lesson",
      categories: [
        "Time & urgency",
        "Everyday feelings",
        "Choices & decisions",
      ],
      descriptions: [
        "The everyday phrase for when you’re short on time.",
        "A natural way to say you’re feeling under pressure.",
        "The words that go together when it’s time to choose.",
      ],
      note: "3 short lessons · English audio & subtitles · Persian explanations",
      next: "See how learning continues in the app",
      error: "The video couldn’t play. Try again or open the video directly.",
      retry: "Try again",
      open: "Open video",
    },
    pillars: [
      "Real-world videos",
      "Learning in context",
      "Practice with feedback",
      "A guided journey",
    ],
    philosophyLabel: "FROM KNOWING TO USING",
    philosophy: "You know the words.",
    philosophyAccent: "Make them work together.",
    philosophyBody:
      "Natural English is about the words that belong together. Lingogram helps you hear, understand, and practice collocations—common word combinations—in real situations.",
    exampleLabel: "FAMILIAR WORDS. THE RIGHT COMBINATION.",
    exampleTranslation: "Words that belong together.",
    methodLabel: "THE LEARNING LOOP",
    methodTitle: "Watch. Understand. Make it yours.",
    methodBody:
      "One connected experience, from hearing a phrase for the first time to understanding how it works.",
    steps: [
      {
        title: "Hear it as it happens.",
        short: "Watch",
        body: "Discover expressions in real videos with subtitles. Hear the tone, see the context, and give every phrase a meaning.",
        label: "Real language. Real context.",
      },
      {
        title: "Understand the meaning. Learn the use.",
        short: "Understand",
        body: "Clear lesson notes help you see which words belong together, and why one combination sounds more natural.",
        label: "Clear explanations. Focused learning.",
      },
      {
        title: "Try it. Then understand why.",
        short: "Practice",
        body: "Test your understanding with varied questions. Answer feedback explains why a phrase works, so you can learn from each attempt.",
        label: "Short practice. Useful feedback.",
      },
    ],
    experienceLabel: "DESIGNED TO KEEP YOU GOING",
    experienceTitle: "Small steps.\nVisible progress.",
    experienceBody:
      "Know where you are and what comes next. Your lessons, practice, and saved expressions each have a place.",
    journeyTitle: "See your way forward.",
    journeyBody:
      "Move from one lesson to the next and follow your progress along a visual learning path.",
    libraryTitle: "Your phrases. Your collection.",
    libraryBody:
      "Find your saved expressions in a personal library, ready whenever you want to revisit them.",
    progressTitle: "A reason to come back.",
    progressBody:
      "Completed steps and your daily streak make your small efforts visible.",
    galleryLabel: "A CLOSER LOOK",
    galleryTitle: "Meet your everyday English app.",
    galleryBody:
      "Switch between screens to explore the real Lingogram experience.",
    galleryTabs: [
      "Your journey",
      "Video & practice",
      "Lesson notes",
      "Your library",
    ],
    galleryDescriptions: [
      "Completed lessons, your current stage, and the next step in one clear path.",
      "Video, subtitles, and practice feedback in one experience.",
      "Short notes that explain natural English word combinations.",
      "A dedicated home for the expressions you want to keep.",
    ],
    actualScreen: "CAPTURED IN THE ANDROID APP",
    screenshotLanguage: "The current app interface is in English.",
    faqLabel: "GOOD TO KNOW",
    faqTitle: "Before your first step.",
    faqs: [
      [
        "Is Lingogram right for me?",
        "Lingogram is designed for learners who know basic English and want to use more natural, practical expressions. The current release focuses on English collocations.",
      ],
      [
        "Which languages does the app support?",
        "This website is available in Persian and English. The current app interface and learning content are in English. The screenshots here show the actual app.",
      ],
      [
        "How do I install it?",
        "Select Get for Android and open the downloaded APK. If Android asks, allow installation from your browser, then continue with the installation. Download the file from this website.",
      ],
      [
        "Do I need an internet connection?",
        "Yes. You need an internet connection to load lesson content and play videos.",
      ],
      [
        "Is there an iPhone version?",
        "Lingogram is currently available for Android. An iOS version has not been released.",
      ],
    ],
    ctaLabel: "YOUR NEXT STEP",
    ctaTitle: "A new phrase.\nA different beginning.",
    ctaBody:
      "Get Lingogram and start learning English in the context of real life.",
    install: [
      "Download the APK",
      "Open it and allow installation",
      "Open Lingogram and get started",
    ],
    requirement: "Android 7 or later",
    footer: "English, closer to life.",
    rights: "All rights reserved.",
    back: "Back to top",
    title: "Lingogram | English for real life",
    description:
      "Learn English collocations with real videos, focused lessons, and practice with feedback. Download Lingogram for Android.",
  },
} as const;
